import { createSlice } from '@reduxjs/toolkit'
import { createAsyncActions } from '@/utils/sagas'

const initialState = {
  hasInitialized: false,
  isFetching: false,
  error: null,
  items: [],
}

export const fetchInstalledApps = createAsyncActions('apps/installed')
export const installApp = createAsyncActions('apps/install')
export const installTrustedApp = createAsyncActions('apps/install/trusted')
export const uninstallApp = createAsyncActions('apps/uninstall')

/*
  List of installed apps on license
*/
const installedAppsSlice = createSlice({
  name: 'installedApps',
  initialState,
  reducers: {
    installAppNotLoggedIn() {},
    installTrustedAppNotLoggedIn() {},
  },
  extraReducers: ({ addCase }) => {
    addCase(fetchInstalledApps.pending, (state) => {
      state.isFetching = true
      state.error = null
    })

    addCase(fetchInstalledApps.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items = payload.items
      state.hasInitialized = true
    })

    addCase(fetchInstalledApps.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(installTrustedApp.pending, (state) => {
      state.isFetching = true
      state.error = null
    })

    addCase(installTrustedApp.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(installApp.pending, (state) => {
      state.isFetching = true
      state.error = null
    })

    addCase(installApp.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items = [...state.items, payload.id]
    })

    addCase(installApp.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(uninstallApp.pending, (state) => {
      state.isFetching = true
      state.error = null
    })

    addCase(uninstallApp.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items = state.items.filter((item) => item !== payload.id)
    })

    addCase(uninstallApp.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })
  },
})

export const { installAppNotLoggedIn, installTrustedAppNotLoggedIn } =
  installedAppsSlice.actions
export const reducer = installedAppsSlice.reducer
